import styles from './style.postcss';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PageCard, Icon, moment } from 'omni-common-ui';
import UserCard from 'components/UserCard';
import is from 'is_js';

class RejectNote extends PureComponent {

  render() {
    const { note, teacherId, timeZone, rejectTime } = this.props;
    const dateStr = is.existy(rejectTime) && is.existy(timeZone) ?
      moment.parseZone(rejectTime).clone().tz(timeZone).format('YYYY-MM-DD') : '';
    return <PageCard>
      <PageCard.Heading text="Reject Notes" />
      <PageCard.Content>
        <div>
          {
            teacherId && <UserCard id={teacherId.toString()}
                dateStr={dateStr} />
          }
        </div>
        <p className={styles.RejectNote_content}>
          {note || '–'}
        </p>
        <div className={styles.RejectNote_content_info}>
          <Icon id="info" className={styles.RejectNote_content_info_icon} />
          <span>This note will not be published to EF Parents.</span>
        </div>
      </PageCard.Content>
    </PageCard>;
  }
}

RejectNote.propTypes = {
  note: PropTypes.string.isRequired,
  teacherId: PropTypes.number.isRequired,
  timeZone: PropTypes.string,
  rejectTime: PropTypes.string,
};

export default RejectNote;



// WEBPACK FOOTER //
// ./components/RejectNote/index.jsx